function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import React from 'react';
import Modal from 'react-overlays/Modal';
import { modalManager } from './Modal';
const styles = require('./Drawer-styles.module.scss');

function Drawer({
  show,
  onHide,
  className,
  children
}) {
  return React.createElement(Modal, {
    show: show,
    onHide: onHide,
    manager: modalManager // FIXME: this isn't correct
    ,
    enforceFocus: false,
    renderBackdrop: props => React.createElement("div", _extends({}, props, {
      className: styles.backdrop
    })),
    renderDialog: props => React.createElement("div", _extends({}, props, {
      className: className
    }), children)
  });
}

export default Drawer;